import type { ActivitiesFiltersParams } from '@core/activities-types';
import { createSingleEntityStore, pipeState } from '@core/ngrx-legacy';

import type { NotificationCounterFilteredStore } from '../../types';
import { EntityStoreKey } from '../../types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<NotificationCounterFilteredStore>()(
    EntityStoreKey.notificationsCounterFiltered,
    {
      customActions: adapter => ({
        fetch: (state, payload: { filters: ActivitiesFiltersParams }) =>
          pipeState(state, next => adapter.markAsPending(next)),
      }),
    },
  );

export {
  actions as NotificationsCounterFilteredActions,
  selectors as NotificationsCounterFilteredSelectors,
  reducer as NotificationsCounterFilteredReducer,
  namespace as NotificationsCounterFilteredNamespace,
};
